// ===================================
// LittleG interactive platform constants
// Updated: 2026-08-04
// ===================================
(function () {
  'use strict';

  var interactionDebounceTimer = 300;
  var littlegEvents = {
    gfunBalanceUpdate: 'gfun:updated',
    gfunConsume: 'gfun-consume',
    gfunRecharge: 'gfun-recharge',
    voiceRecordingStart: 'voice-recording-start',
    voiceRecordingStop: 'voice-recording-stop',
    voiceTranscriptionComplete: 'voice-transcription-complete',
    mapLocationSelect: 'map-location-select',
    mapMarkerAdd: 'map-marker-add',
    mapRouteUpdate: 'map-route-update',
    serviceOptionChange: 'service-option-change',
    aiModelSelect: 'ai-model-select',
    deliveryMethodChange: 'delivery-method-change',
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change',
    cartError: 'cart-error',
    apiTriggerStart: 'api-trigger-start',
    apiTriggerComplete: 'api-trigger-complete',
    apiTriggerError: 'api-trigger-error',
    /* 4+1 Unified Search & Intent Event Bus */
    globalSearchOpen: 'littleg:search:open',
    globalSearchDispatch: 'littleg:search:dispatch',
    commandPaletteOpen: 'littleg:command-palette:open',
    composerFocus: 'littleg:composer:focus',
  };

  window.INTERACTION_DEBOUNCE_TIMER = interactionDebounceTimer;
  window.LITTLEG_EVENTS = littlegEvents;
})();

/* GLOBAL-LOCALE-RUNTIME-02
   Owner: assets/constants.js owns shared runtime locale context, locale-aware date/time formatting,
   dynamic accessibility projection and state preservation around Shopify localization submits.
   Liquid remains the authority for server-rendered copy. Page runtimes may consume window.LITTLEG_LOCALE.
   Boundary: no language-market form creation, no route ownership and no business-data mutation. */
(function globalLocaleRuntime(window, document) {
  'use strict';

  var VERSION = '2026-08-01-global-locale-runtime-02';
  if (!window || !document || window.__LITTLEG_GLOBAL_LOCALE__ === VERSION) return;
  window.__LITTLEG_GLOBAL_LOCALE__ = VERSION;

  var TIME_ZONE = 'Asia/Hong_Kong';
  var HASH_KEY = 'littleg_locale_return_hash_v1';
  var DRAFT_KEY_PREFIX = 'littleg_locale_form_draft_v1:';
  var observer = null;
  var scheduled = false;
  var applying = false;

  var COPY = {
    'zh-HK': {
      gameLabel: 'LittleG 香港城市探索',
      currentMarker: '目前標記：{value}',
      unselected: '尚未選擇',
      minute: '分鐘',
      timeUp: '時間到，跳到猜答案。',
    },
    'zh-TW': {
      gameLabel: 'LittleG 香港城市探索',
      currentMarker: '目前標記：{value}',
      unselected: '尚未選擇',
      minute: '分鐘',
      timeUp: '時間到，跳到猜答案。',
    },
    'zh-CN': {
      gameLabel: 'LittleG 香港城市探索',
      currentMarker: '当前标记：{value}',
      unselected: '尚未选择',
      minute: '分钟',
      timeUp: '時間到，跳到猜答案。',
    },
    en: {
      gameLabel: 'LittleG Hong Kong city exploration',
      currentMarker: 'Current marker: {value}',
      unselected: 'Not selected',
      minute: 'min',
      timeUp: 'Time is up. You can keep looking for clues or move on to your guess.',
    },
  };

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function normalizeLocale(value) {
    var raw = clean(value || 'en')
      .replace(/_/g, '-')
      .toLowerCase();
    if (raw === 'zh-cn' || raw === 'zh-hans' || raw === 'zh-sg') return 'zh-CN';
    if (raw === 'zh-tw') return 'zh-TW';
    if (raw === 'zh-hk' || raw === 'zh-hant' || raw === 'zh-mo') return 'zh-HK';
    return 'en';
  }

  function locale() {
    return normalizeLocale(
      document.documentElement.getAttribute('lang') ||
        (window.Shopify && window.Shopify.locale) ||
        'en'
    );
  }

  function table() {
    return COPY[locale()] || COPY.en;
  }

  function t(key, variables) {
    var value = table()[key] || COPY.en[key] || key;
    Object.keys(variables || {}).forEach(function (name) {
      value = value.replace(new RegExp('\\{' + name + '\\}', 'g'), String(variables[name]));
    });
    return value;
  }

  function validDate(value) {
    var date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function format(value, options) {
    var date = validDate(value);
    if (!date) return clean(value);
    try {
      return new Intl.DateTimeFormat(
        locale(),
        Object.assign({ timeZone: TIME_ZONE }, options || {})
      ).format(date);
    } catch (_) {
      return clean(value);
    }
  }

  function formatDate(value, options) {
    return format(
      value,
      Object.assign({ year: 'numeric', month: 'short', day: 'numeric' }, options || {})
    );
  }

  function formatTime(value, options) {
    return format(
      value,
      Object.assign(
        { hour: '2-digit', minute: '2-digit', hour12: locale() !== 'en' },
        options || {}
      )
    );
  }

  function formatDateTime(value, options) {
    return format(
      value,
      Object.assign(
        { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' },
        options || {}
      )
    );
  }

  function setAttribute(node, name, value) {
    if (!node) return;
    value = String(value);
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }

  function setText(node, value) {
    if (!node) return;
    value = String(value);
    if (node.textContent !== value) node.textContent = value;
  }

  function syncHtmlContext() {
    var code = locale();
    var html = document.documentElement;
    setAttribute(html, 'data-locale', code);
    setAttribute(html, 'data-is-en', code === 'en' ? 'true' : 'false');
    setAttribute(html, 'data-is-zh', code === 'en' ? 'false' : 'true');
    setAttribute(html, 'dir', 'ltr');
  }

  function projectDates(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(
      root.querySelectorAll(
        'time[datetime], [data-locale-date], [data-locale-datetime], [data-locale-time]'
      ),
      function (node) {
        var raw =
          node.getAttribute('datetime') ||
          node.getAttribute('data-locale-datetime') ||
          node.getAttribute('data-locale-date') ||
          node.getAttribute('data-locale-time');
        if (!raw) return;
        if (node.hasAttribute('data-locale-time')) setText(node, formatTime(raw));
        else if (node.hasAttribute('data-locale-date')) setText(node, formatDate(raw));
        else setText(node, formatDateTime(raw));
        setAttribute(node, 'data-locale-projected', locale());
      }
    );
  }

  function projectGame(scope) {
    var root = scope && scope.querySelector ? scope.querySelector('[data-littleg-game-app]') : null;
    if (!root && scope && scope.matches && scope.matches('[data-littleg-game-app]')) root = scope;
    if (!root) root = document.querySelector('[data-littleg-game-app]');
    if (!(root instanceof HTMLElement)) return;

    setAttribute(root, 'lang', locale());
    setAttribute(root, 'data-locale', locale());
    setAttribute(root, 'aria-label', t('gameLabel'));

    var pin = root.querySelector('[data-lg-map-pin]');
    if (pin)
      setAttribute(
        pin,
        'aria-label',
        t('currentMarker', { value: clean(root.dataset.district) || t('unselected') })
      );

    var duration = root.querySelector('[data-lg-mission-duration]');
    if (duration) {
      var value = clean(root.dataset.missionDuration);
      setText(duration, value ? value + ' ' + t('minute') : '—');
    }

    var clock = root.querySelector('[data-lg-status-time]');
    if (clock) {
      setText(clock, formatTime(new Date(), { hour12: false }));
      setAttribute(clock, 'data-locale-clock', locale());
    }

    var toast = root.querySelector('[data-lg-toast]');
    if (toast && /時間到|时间到|time is up/i.test(clean(toast.textContent)))
      setText(toast, t('timeUp'));
  }

  function selectedForms() {
    return Array.prototype.slice.call(
      document.querySelectorAll('form[data-preserve-locale-draft="true"]')
    );
  }

  function draftKey(form, index) {
    var id = clean(
      form.id || form.getAttribute('name') || form.getAttribute('data-form-id') || index
    );
    return (
      DRAFT_KEY_PREFIX +
      window.location.pathname.replace(/^\/[a-z]{2,3}(?:-[a-z0-9]{2,8})*(?=\/)/i, '') +
      ':' +
      id
    );
  }

  function serializeForm(form) {
    var values = {};
    Array.prototype.forEach.call(form.elements || [], function (field) {
      if (
        !field ||
        !field.name ||
        field.disabled ||
        field.type === 'password' ||
        field.type === 'file'
      )
        return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      if (values[field.name] == null) values[field.name] = field.value;
      else if (Array.isArray(values[field.name])) values[field.name].push(field.value);
      else values[field.name] = [values[field.name], field.value];
    });
    return values;
  }

  function saveLocaleDrafts() {
    selectedForms().forEach(function (form, index) {
      try {
        window.sessionStorage.setItem(draftKey(form, index), JSON.stringify(serializeForm(form)));
      } catch (_) {}
    });
  }

  function restoreLocaleDrafts() {
    selectedForms().forEach(function (form, index) {
      var key = draftKey(form, index);
      var raw = '';
      var values;

      try {
        raw = window.sessionStorage.getItem(key) || '';
      } catch (_) {}

      if (!raw) return;

      try {
        values = JSON.parse(raw);
      } catch (_) {
        values = null;
      }

      if (!values || typeof values !== 'object') {
        try {
          window.sessionStorage.removeItem(key);
        } catch (_) {}
        return;
      }

      Object.keys(values).forEach(function (name) {
        var fields = form.querySelectorAll('[name="' + String(name).replace(/"/g, '\\"') + '"]');

        Array.prototype.forEach.call(fields, function (field) {
          var value = values[name];
          var list = Array.isArray(value) ? value.map(String) : [String(value)];

          if (field.type === 'checkbox' || field.type === 'radio') {
            field.checked = list.indexOf(String(field.value)) !== -1;
          } else {
            field.value = Array.isArray(value) ? value[0] : value;
          }
        });
      });

      try {
        window.sessionStorage.removeItem(key);
      } catch (_) {}
    });
  }

  function isLocalizationForm(form) {
    if (!form) return false;
    var type = form.querySelector('input[name="form_type"][value="localization"]');
    return !!type || /\/localization(?:\?|$)/.test(clean(form.action));
  }

  function beforeLocalizationSubmit(event) {
    var form = event.target;
    if (!isLocalizationForm(form)) return;

    saveLocaleDrafts();

    try {
      if (window.location.hash) {
        window.sessionStorage.setItem(HASH_KEY, window.location.hash);
      }
    } catch (_) {}

    setAttribute(document.documentElement, 'data-locale-applying', 'true');
  }

  function restoreHash() {
    if (window.location.hash) return;
    var hash = '';
    try {
      hash = clean(window.sessionStorage.getItem(HASH_KEY));
      window.sessionStorage.removeItem(HASH_KEY);
    } catch (_) {}
    if (!/^#[A-Za-z][\w:.-]*$/.test(hash)) return;
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + window.location.search + hash
    );
  }

  function apply(scope) {
    if (applying) return;
    applying = true;
    try {
      syncHtmlContext();
      projectDates(scope || document);
      projectGame(scope || document);
    } finally {
      applying = false;
    }
  }

  function schedule(scope) {
    if (scheduled || applying) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      apply(scope || document);
    });
  }

  function boot() {
    syncHtmlContext();
    restoreHash();
    restoreLocaleDrafts();
    apply(document);
    document.addEventListener('submit', beforeLocalizationSubmit, true);
    window.setInterval(function () {
      var root = document.querySelector('[data-littleg-game-app]');
      if (root) projectGame(root);
    }, 60000);
    if (window.MutationObserver) {
      observer = new MutationObserver(function (mutations) {
        if (applying) return;
        var shouldApply = mutations.some(function (mutation) {
          return (
            mutation.type === 'childList' ||
            mutation.type === 'characterData' ||
            mutation.attributeName === 'datetime'
          );
        });
        if (shouldApply) schedule(document);
      });
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['datetime'],
      });
    }
    document.dispatchEvent(
      new CustomEvent('littleg:locale-ready', { detail: { locale: locale(), version: VERSION } })
    );
  }

  window.LITTLEG_LOCALE = Object.freeze({
    VERSION: VERSION,
    code: locale(),
    getCode: locale,
    normalize: normalizeLocale,
    isEnglish: function () {
      return locale() === 'en';
    },
    isChinese: function () {
      return locale() !== 'en';
    },
    timeZone: TIME_ZONE,
    t: t,
    formatDate: formatDate,
    formatTime: formatTime,
    formatDateTime: formatDateTime,
    saveDrafts: saveLocaleDrafts,
    restoreDrafts: restoreLocaleDrafts,
    apply: apply,
  });

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(window, document);
